import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "cart-sum__label" };
var _hoisted_2 = { class: "cart-sum__value" };
import Price from "../Price.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSumPart',
    props: {
        label: { type: String, required: true },
        amount: Number,
        showZero: Boolean,
    },
    setup: function (__props) {
        var props = __props;
        var show = computed(function () { return props.amount ? true : props.showZero ? props.amount !== undefined : false; });
        return function (_ctx, _cache) {
            return (show.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("dt", _hoisted_1, _toDisplayString(__props.label), 1 /* TEXT */),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("dd", _hoisted_2, [
                        _createVNode(Price, { amount: __props.amount }, null, 8 /* PROPS */, ["amount"])
                    ])
                ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true);
        };
    }
});
